import React, { useState, useEffect } from 'react';
import CSUSLogo from '../../Assets/CSUS_logo.png';
import '../Styles/DesktopNavbar.css';

const useActiveLink = () => {
  const [activeLink, setActiveLink] = useState(null);

  useEffect(() => {
    function handleNavigation() {
      const pathName = window.location.pathname + window.location.hash;
      const links = [
        { name: 'Home', route: '/' },
        { name: 'Team', route: '/#team' },
        { name: 'Events', route: '/#events' },
        { name: 'Contact', route: '/#contact' },
        { name: 'Resources', route: '/resources' },
        { name: 'Resources', route: '/resources#academic-resources' },
        { name: 'Resources', route: '/resources#recruiting-resources' },
        { name: 'Resources', route: '/resources#event-resources' },
        { name: 'Resources', route: '/resources#constitution' }
      ];

      const matchingLink = links.find(link => {
        return link.route === pathName || (link.route === '/' && pathName === '/');
      });

      if (matchingLink) {
        setActiveLink(matchingLink.name);
      } else {
        setActiveLink(null);
      }
    }

    handleNavigation(); 
    window.addEventListener('hashchange', handleNavigation);
    window.addEventListener('popstate', handleNavigation); 

    return () => {
      window.removeEventListener('hashchange', handleNavigation);
      window.removeEventListener('popstate', handleNavigation);
    };
  }, []);

  return activeLink;
};

const DesktopNavbar = () => {
  const activeLink = useActiveLink();
  const baseUrl = window.location.origin;

  return (
    <nav className="desktop_navbar">
      <div className="desktop_navbar_logo_div">
        <img className="desktop_navbar_logo" src={CSUSLogo} alt="CSUS_logo" />
      </div>
      <div className="navbar_links">
        <a className={`desktop_navbar_link ${activeLink === 'Home' ? 'active' : ''}`} href={`${baseUrl}/`}>Home</a>
        <a className={`desktop_navbar_link ${activeLink === 'Team' ? 'active' : ''}`} href={`${baseUrl}/#team`}>Team</a>
        {/* <a className={`desktop_navbar_link ${activeLink === 'Events' ? 'active' : ''}`} href={`${baseUrl}/#events`}>Events</a> */}
        <a className={`desktop_navbar_link ${activeLink === 'Contact' ? 'active' : ''}`} href={`${baseUrl}/#contact`}>Contact</a>
        {/* <a className={`desktop_navbar_link ${activeLink === 'Resources' ? 'active' : ''}`} href={`${baseUrl}/resources`}>Resources</a> */}
      </div>
      <a href="https://westernusc.store/product/computer-science/"><button className="join_button" >Join now</button></a>
    </nav>
  );
};

export default DesktopNavbar;
